import React from 'react'
import { flowRight } from 'lodash'
import { Trans, useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import PropTypes from 'prop-types'
import { NOTIFICATION_TYPE } from 'components/Notifications/Notifications'
import { newNotification } from 'lib/utils/store/notifications'
import useCurrentUser from 'lib/hooks/useCurrentUser'

import ExtendedFormik from 'components/Forms/ExtendedFormik'
import Button from 'components/UI/Button'
import { Form } from 'formik'
import ErrorComponent from 'components/Errors/ErrorComponent'
import AppContext from 'components/AppContext'

import updateMeMutation from 'graphql/user/updateMe.gql'

/**
 * Sync user strong identification name with account name.
 */
const UserSyncIdentificationName = ({ onSubmitted }) => {
    const currentUser = useCurrentUser()
    const user = currentUser.me.user
    const firstName = user?.lastIdentification?.firstName ?? user?.firstName
    const lastName = user?.lastIdentification?.lastName ?? user?.lastName
    const fullName = `${firstName} ${lastName}`
    const [updateMe, { loading: updateMeLoading, error: updateMeError }] = useMutation(updateMeMutation)

    const { t } = useTranslation('user')

    return (
        <AppContext context="userSyncIdentificationName">
            <div className="user-sync-identification-name">
                <p>
                    <Trans i18nKey="user:userSyncIdentificationName.description" fullName={fullName}>
                        <b>{{ fullName }}</b>
                    </Trans>
                </p>
                <ExtendedFormik
                    id="user-sync-identification-name"
                    initialValues={{
                        firstName: firstName,
                        lastName: lastName,
                    }}
                    onSubmit={(values) => {
                        return updateMe({
                            variables: {
                                userInput: {
                                    firstName: firstName,
                                    lastName: lastName,
                                },
                            },
                        }).then(() => {
                            newNotification(
                                NOTIFICATION_TYPE.SUCCESS,
                                '',
                                t('user:userSyncIdentificationName.submitSuccess')
                            )
                            onSubmitted && onSubmitted()
                        })
                    }}
                >
                    {() => (
                        <Form className="vehicle-status-form">
                            {updateMeError && <ErrorComponent error={updateMeError} />}
                            <div className="action-wrapper">
                                <Button
                                    key="confirm"
                                    type="submit"
                                    className="button"
                                    trackName="submit"
                                    loading={updateMeLoading}
                                    disabled={updateMeLoading}
                                >
                                    {t('user:userSyncIdentificationName.submit')}
                                </Button>
                                <Button
                                    key="cancel"
                                    type="button"
                                    className="button button--secondary"
                                    trackName="closeModal"
                                    onClick={onSubmitted}
                                >
                                    {t('user:userSyncIdentificationName.cancel')}
                                </Button>
                            </div>
                        </Form>
                    )}
                </ExtendedFormik>
            </div>
        </AppContext>
    )
}

UserSyncIdentificationName.propTypes = {
    onSubmitted: PropTypes.func,
}

export default flowRight(
    withRouter,
)(UserSyncIdentificationName)
